/**
 * LayersIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LayersIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.584 13.376a.75.75 0 0 1 .833 1.248l-9.01 6.02-.004.002-.01.005a.8.8 0 0 1-.257.105q-.022.003-.045.004a.8.8 0 0 1-.247-.004l-.023-.007a.7.7 0 0 1-.249-.105l-8.989-6.02a.75.75 0 0 1 .834-1.247l8.573 5.74z" />
    <path
      fillRule="evenodd"
      d="M11.694 3.321a.75.75 0 0 1 .737.056l8.987 6.025a.75.75 0 0 1-.001 1.246l-9.014 6.025a.75.75 0 0 1-.834-.001l-8.987-6.025A.75.75 0 0 1 2.583 9.4l9.014-6.025zm-7.346 6.704 7.64 5.122 7.662-5.124-7.637-5.12z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const LayersIcon = makeIcon('LayersIcon', LayersIconSvg)
